import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Chip,
    colors
} from '@material-ui/core';

import {
    Label
} from '../../../../common';

import { PageContext } from '../PageContext';

import { ApplicationRoles } from '../../../../../helpers';

import PeopleIcon from '@material-ui/icons/People';
import CloudIcon from '@material-ui/icons/CloudOutlined';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    header: {
        color: colors.blueGrey[500],
        backgroundColor: colors.grey[200]
    },
}));

export const RoleDetails = ({ ...props }) => {
    const classes = useStyles();

    const {
        state
    } = useContext(PageContext);

    const {
        role
    } = state;

    const getUserNamesList = () => {
        if (role.users && role.users.length > 0) {
            return role.users.map((user, index) =>
                <span key={index}>{user.displayName};&nbsp;</span>
            );
        } else {
            return "No Members";
        }
    }

    return (
        <Card className={clsx(classes.root, props.className)}>
            <CardHeader
                className={classes.header}
                title={
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item>
                            <Typography variant="h6">
                                Role Info
                            </Typography>
                        </Grid>
                    </Grid>
                }
            />
            <CardContent>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell>
                                Name
                            </TableCell>
                            <TableCell>
                                {role.groupName}
                            </TableCell>
                        </TableRow>                        
                        <TableRow>
                            <TableCell>
                                Group Type
                            </TableCell>
                            <TableCell>
                                {role.groupAADReference === null ?
                                    <Chip
                                        icon={<PeopleIcon />}
                                        label="Application"
                                        variant="outlined"
                                    />
                                    :
                                    <Chip
                                        icon={<CloudIcon />}
                                        label="Active Directory"
                                        variant="outlined"
                                    />
                                }
                            </TableCell>
                        </TableRow>
                        {role.groupAADReference !== null &&
                            <TableRow>
                                <TableCell>
                                    Azure AD ID
                        </TableCell>
                                <TableCell>
                                    {role.groupAADReference}
                                </TableCell>
                            </TableRow>
                        }
                        <TableRow>
                            <TableCell>
                                Management
                            </TableCell>
                            <TableCell>
                                {role.roleName === ApplicationRoles.Administrator ?
                                    <Label color={colors.grey[500]}>                                    
                                        Users with this role can view or manage any table
                                    </Label>
                                    :
                                    <Label color={role.isManagement ? colors.green[500] : colors.red[500]}>
                                        {role.isManagement ? "Users with this role can manage tables" : "Users with this role can't manage tables"}
                                    </Label>
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Total Users
                            </TableCell>
                            <TableCell>
                                {role.users.length}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                All Users
                            </TableCell>
                            <TableCell>
                                {getUserNamesList()}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Description
                                </TableCell>
                            <TableCell>
                                {role.description || "-"}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
}